// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".SearchBar__container--nOka8 {\n  position: relative;\n  display: flex;\n  height: 100%;\n  width: 100%;\n}\n\n.SearchBar__search-icon--2-_5D {\n  fill: #424242;\n}\n", "",{"version":3,"sources":["SearchBar.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;AACf","file":"SearchBar.css","sourcesContent":[".container {\n  position: relative;\n  display: flex;\n  height: 100%;\n  width: 100%;\n}\n\n.search-icon {\n  fill: #424242;\n}\n"]}]);
// Exports
exports.locals = {
	"container": "SearchBar__container--nOka8",
	"search-icon": "SearchBar__search-icon--2-_5D",
	"searchIcon": "SearchBar__search-icon--2-_5D"
};
module.exports = exports;
